import React from 'react';
import { useBrandingColors } from '../../../hooks/useBrandingColors';
import type { VacancyFieldStatus } from './types';
import circleCheckIcon from '../../../assets/icons/circle-check.png';
import aiSunIcon from '../../../assets/icons/ai-sun-icon.png';

interface FieldProgressListProps {
  fields: VacancyFieldStatus[];
  title?: string;
  subtitle?: string;
}

export function FieldProgressList({ fields, title = 'Создаю вакансию...', subtitle = 'Финализирую...' }: FieldProgressListProps) {
  const colors = useBrandingColors();
  const isStillProcessing = fields.some(f => f.status === 'pending');

  return (
    <div className="flex flex-col gap-1">
      {/* Header with spinning sun icon - only while processing */}
      {isStillProcessing && (
        <div className="flex items-center gap-3 mb-3">
          <img
            src={aiSunIcon}
            alt=""
            className="w-10 h-10 shrink-0 ai-icon-spin"
          />
          <div>
            <div className="text-[14px] font-medium text-[#0a0d14]">{title}</div>
            <div className="text-[12px] text-[#868C98]">{subtitle}</div>
          </div>
        </div>
      )}

      {/* Field list */}
      {fields.map((field) => (
        <div key={field.key} className="flex items-center justify-between py-2 border-b border-[#f0f1f3] last:border-b-0">
          <span className={`text-[14px] ${field.status === 'no_data' ? 'text-[#868C98]' : 'text-[#0a0d14]'}`}>
            {field.label}
          </span>
          <span className="shrink-0 ml-2">
            {field.status === 'filled' ? (
              <img src={circleCheckIcon} alt="✓" className="w-5 h-5 ai-fade-in" />
            ) : field.status === 'no_data' ? (
              <span className="text-[12px] text-[#868C98]">нет данных</span>
            ) : (
              <div
                className="w-5 h-5 rounded-full border-2 border-t-transparent animate-spin"
                style={{ borderColor: '#CDD0D5', borderTopColor: 'transparent' }}
              />
            )}
          </span>
        </div>
      ))}
    </div>
  );
}
